import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import axios from "axios";
import { IMAGES, CONTENT, PROJECTS, GALLERY } from "../data/site";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Gallery } from "../components/Gallery";
import { EditorialMarquee } from "../components/Marquee";
import { Trust } from "../components/Trust";
import { About } from "../components/About";
import { Services } from "../components/Services";
import { StructuralDesign } from "../components/StructuralDesign";
import { Prefab } from "../components/Prefab";
import { Process } from "../components/Process";
import { Projects } from "../components/Projects";
import { WhyUs } from "../components/WhyUs";
import { CtaBanner } from "../components/CtaBanner";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { WhatsAppFloat } from "../components/WhatsAppFloat";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Landing() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/site-images`).catch(() => null),
      axios.get(`${API}/content`).catch(() => null),
      axios.get(`${API}/projects`).catch(() => null),
      axios.get(`${API}/gallery`).catch(() => null),
    ])
      .then(([imgs, content, projects, gallery]) => {
        if (imgs?.data) Object.assign(IMAGES, imgs.data);
        if (content?.data) Object.assign(CONTENT, content.data);
        if (Array.isArray(projects?.data) && projects.data.length) {
          PROJECTS.splice(0, PROJECTS.length, ...projects.data);
        }
        if (Array.isArray(gallery?.data)) {
          GALLERY.splice(0, GALLERY.length, ...gallery.data);
        }
      })
      .finally(() => setReady(true));
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#050505]" data-testid="landing-loading">
        <span className="flex h-12 w-12 animate-pulse items-center justify-center bg-[#0055FF] font-display text-lg font-bold text-white">
          RR
        </span>
      </div>
    );
  }

  return (
    <div data-testid="landing-page" className="bg-[#050505] text-[#F5F5F5]">
      <div className="grain-overlay" aria-hidden />
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Trust />
        <About />
        <Services />
        <StructuralDesign />
        <Prefab />
        <Process />
        <Projects />
        <Gallery />
        <WhyUs />
        <CtaBanner />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
